import { render, staticRenderFns } from "./ProductSuggest.vue?vue&type=template&id=6e706f50"
import script from "./ProductSuggest.vue?vue&type=script&lang=js"
export * from "./ProductSuggest.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports